import NestedMenuItemList, { NestedMenuItemListProps } from './NestedMenuItemList';

export type { NestedMenuItemListProps };
export default NestedMenuItemList;
